<template>
  <nav class="nav nav-default">
    <div class="nav-logo float-left">
      <router-link :to="'/'">
        <img class="logo-img" src="@/assets/images/logos/BPLogo-01.svg" alt="logo-img">
      </router-link>
      <!-- RouterConstants enable locale
      export const PRIVACY_POLICY_URL = `${WEBSITE_URL}/:locale/privacy-policy` -->

      <div class="language-outer-navbar">
        <LanguagePicker :on-lang-change="langChanged" />
      </div>
    </div>
    <div class="nav-logo float-right">
      <a class="link" :href="WEBSITE_URL">beyondpulse.com</a>
    </div>
  </nav>
</template>

<script>
import { WEBSITE_URL } from '@/constants/RouterConstants'
import LanguagePicker from '@/components/common/LanguagePicker'
import { mapActions } from 'vuex'
import { LANGUAGE_CHANGED_ON_SIGN_UP } from '@/store/action.types'

export default {
  name: 'Navbar',
  data () {
    return {
      WEBSITE_URL
    }
  },
  methods: {
    ...mapActions({
      langChangedOnSignUpAction: LANGUAGE_CHANGED_ON_SIGN_UP
    }),
    langChanged(key) {
      this.langChangedOnSignUpAction();
    }
  },
  components : {
    LanguagePicker
  }
}
</script>

<style lang="scss" scoped>
  .language-outer-navbar{
    display: inline-block;
    margin-left: 20px;
  }
</style>
